<style>
.scrollable-menu {
    height: auto;
    max-height: 200px;
    overflow-x: hidden;
}

.modal-dialog {
    padding-top: 10%;
}

.modal-body {
    padding-top: 10px;
}

.modal-header {
    padding-left: 10px;
}

.modal-content {
    padding-left: 10px;
}

.termoOfuse {
    text-align: justify;
    text-justify: inter-word;
}
</style>


<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">

                <div class="   base-header__container ">
                    <div class="  d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Упит за презентацију
                        </h1>
                    </div>
                </div>
            </div>
        </section>


        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec  p-4">


                <b-form @submit.stop.prevent="onSubmit">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Назив правног лица *</label>
                                <b-form-input type="text" class="form-control full-width" v-model="$v.companyName.$model">
                                </b-form-input>
                                <div v-if="$v.companyName.$dirty">
                                    <div class="form-error" v-if="!$v.companyName.required">Поље је обавезно</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Контакт особа / Име и презиме *</label>
                                <b-form-input type="text" class="form-control full-width" v-model="$v.contactName.$model">
                                </b-form-input>
                                <div v-if="$v.contactName.$dirty">
                                    <div class="form-error" v-if="!$v.contactName.required">Поље је обавезно</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label" for="city">Град / Место *</label>
                                <input type="text" class="form-control full-width" id="city" v-model="$v.city.$model" />
                                <div v-if="$v.city.$dirty">
                                    <div class="form-error" v-if="!$v.city.required">Поље је обавезно</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label" for="addressId">Адреса *</label>
                                <input type="text" class="form-control full-width" id="addressId"
                                    v-model="$v.address.$model" />
                                <div v-if="$v.address.$dirty">
                                    <div class="form-error" v-if="!$v.address.required">Поље је обавезно</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label" for="phoneId">Контакт телефон *</label>
                                <input type="text" class="form-control full-width" id="phoneId" placeholder="0   /       "
                                    v-mask="{ mask: '099/999999[9]', greedy: false }" v-model="$v.phone.$model" />
                                <div v-if="$v.phone.$dirty">
                                    <div class="form-error" v-if="!$v.phone.required">Поље је обавезно</div>
                                    <div class="form-error" v-if="!$v.phone.phoneNum">Унесите исправан број телефона у
                                        формату 000/000000
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label" for="emailId">E-mail адреса *</label>
                                <input type="email" class="form-control full-width" id="emailId"
                                    v-model="$v.email.$model" />
                                <div v-if="$v.email.$dirty">
                                    <div class="form-error" v-if="!$v.email.required">Поље је обавезно</div>
                                    <div class="form-error" v-if="!$v.email.email">Унесите валидну емаил адресу</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Датум презентације *</label>
                                <input id="maskedDateTo_input"
                                    class="form-control full-width masked_date_input_1 form-control" type="text"
                                    @keyup="maskedDateToHandler" v-model="maskedDateTo"
                                    v-mask="{ mask: '99.99.9999', greedy: false }">
                                <datepicker id="date_pick_2" :typeable="true" v-model="$v.schedulePresentation.$model"
                                    input-class="form-control full-width date_input_1" :full-month-name="true"
                                    format="dd.MM.yyyy" :calendar-button="true" calendar-button-icon="icon-calendar1"
                                    :clear-button="true" :disabledDates="disabledDates" clear-button-icon="icon-x"
                                    :bootstrap-styling="true" :language="srCYRL">
                                </datepicker>

                                <div v-if="$v.schedulePresentation.$dirty">
                                    <div class="form-error" v-if="!$v.schedulePresentation.required">Поље је обавезно
                                    </div>

                                    <div class="form-error"
                                        v-if="!$v.schedulePresentation.isValidDate && $v.schedulePresentation.required">
                                        Датум није исправан
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Време презентације *</label>
                                <b-form-select v-model="$v.pickTime.$model" :options="pickTimeOptions"
                                    class="form-control full-width">

                                </b-form-select>
                                <div v-if="$v.pickTime.$dirty">
                                    <div class="form-error" v-if="!$v.pickTime.required">Поље је обавезно</div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group form-group-sm mb-3">
                                <label class="form-label" for="messageId">Порука / Напомена </label>
                                <textarea rows="6" class="form-control full-width" id="messageId"
                                    v-model="message"></textarea>
                            </div>
                        </div>
                    </div>
                    <vue-recaptcha sitekey="6Les_iQoAAAAAFw9HlPGxgxLApXSBvbLsUF_EfTx" :loadRecaptchaScript="true"
                        @verify="onVerify" @expired="onCaptchaExpired" ref="recaptcha">
                    </vue-recaptcha>
                    <div class="form-group form-group-sm ">
                        <b-button :disabled="checkerCaptcha" type="submit" class="btn btn-base-submit text-uppercase mr-3">
                            <span class="icon-search mr-2"></span>
                            Пошаљи упит
                        </b-button>
                    </div>
                </b-form>
                <div v-if="responseMsg">
                    <div class="spacer30"></div>
                    <b-alert show>Упит за заказивање презентације прослеђен је Службеном гласнику. Кориснички сервис ће
                        Вас контактирати у најкраћем року. Службени гласник задржава право да предложени термин и место
                        презентације усклади са својим расположивим ресурсима.
                    </b-alert>
                </div>
            </div>
        </div>
        <b-modal id="confirmation-modal" ref="confirmation-modal" title="Да ли желите да проследите следеће податке?"
            size="lg">
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <table class="table table-striped">
                    <tr>
                        <th>Назив правног лица</th>
                        <td>{{ companyName }}</td>
                    </tr>
                    <tr>
                        <th>Контакт особа</th>
                        <td>{{ contactName }}</td>
                    </tr>
                    <tr>
                        <th>Град / место</th>
                        <td>{{ city }}</td>
                    </tr>
                    <tr>
                        <th>Адреса</th>
                        <td>{{ address }}</td>
                    </tr>
                    <tr>
                        <th>Контакт телефон</th>
                        <td>{{ phone }}</td>
                    </tr>
                    <tr>
                        <th>E-mail адреса</th>
                        <td>{{ email }}</td>
                    </tr>
                    <tr>
                        <th>Датум презентације</th>
                        <td>{{ prettyScheduleDate }}</td>
                    </tr>
                    <tr>
                        <th>Време презентације</th>
                        <td>{{ pickTime }}</td>
                    </tr>
                    <tr>
                        <th>Порука / Напомена</th>
                        <td></td>
                    </tr>
                </table>
                <p>{{ message }}</p>
            </form>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click="abortSend">Не</b-button>
                <b-button variant="info" @click="confirmSend">Да, желим</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
// const isValidDate = (value) => value.indexOf('Invalid date') >= 0;
import { helpers } from 'vuelidate/lib/validators'
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { srCYRL } from 'vuejs-datepicker/dist/locale'
import { required, email } from 'vuelidate/lib/validators'
import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha';
// const phoneNum = helpers.regex('phoneNum', /^[a-zA-Z]*$/);
const phoneNum = helpers.regex('phoneNum', /[0-9]{3}\/[0-9]{6,7}/);


const isValidDate = (value) => {
    let date = moment(value);

    // console.log("isAfter : ", moment(value).isAfter());
    // console.log("true / false : ", date.isValid());
    return date.isValid() && moment(value).isAfter();
};
export default {
    name: "StaticPage",
    data() {
        return {
            checkerCaptcha: true,
            maskedDateTo: null,
            srCYRL: srCYRL,
            // form
            companyName: null,
            contactName: null,
            city: null,
            address: null,
            phone: null,
            email: null,
            schedulePresentation: null,
            pickTime: null,
            pickTimeOptions: [
                { value: null, text: 'Изаберите време' },
                { value: '08:00', text: '08:00' },
                { value: '08:30', text: '08:30' },
                { value: '09:00', text: '09:00' },
                { value: '09:30', text: '09:30' },
                { value: '10:00', text: '10:00' },
                { value: '10:30', text: '10:30' },
                { value: '11:00', text: '11:00' },
                { value: '11:30', text: '11:30' },
                { value: '12:00', text: '12:00' },
                { value: '12:30', text: '12:30' },
                { value: '13:00', text: '13:00' },
                { value: '13:30', text: '13:30' },
                { value: '14:00', text: '14:00' },
                { value: '14:30', text: '14:30' },
                { value: '15:00', text: '15:00' },
            ],
            message: null,

            disabledDates: {
                to: new Date()
            },

            responseMsg: null,
            baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,
            newsletterUrl: window.env.VUE_APP_API_NEWSLETTER_DEV,
             

            presentationApiUrl: window.env.VUE_APP_API_NEWSLETTER_DEV + 'Prins/schedulePresentation',
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        prettyScheduleDate: function () {
            if (this.schedulePresentation !== null) {
                return moment(this.schedulePresentation).format('DD.MM.YYYY')
            }
            return '';
        }
    },
    validations: {
        companyName: { required },
        contactName: { required },
        city: { required },
        address: { required },
        phone: { required, phoneNum },
        email: { required, email },
        schedulePresentation: {
            required,
            isValidDate,
            // minValue: value => value > new Date().toISOString(),

        },
        pickTime: { required },
        pickTimeOptions: { required },

    },
    components: {
        Datepicker,
        VueRecaptcha
    },
    watch: {
        'schedulePresentation': function () {
            this.maskedDateTo = moment(this.schedulePresentation, 'YYYY-MM-DD').format('DD.MM.YYYY');
        }
    },
    methods: {
        onVerify(response) {
            this.recaptcha = response;
            if (this.recaptcha) {
                this.checkerCaptcha = false;
            }
        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
        },
        maskedDateToHandler() {
            if (!this.maskedDateTo.includes("_")) {
                this.schedulePresentation = moment(this.maskedDateTo, 'DD.MM.YYYY').format('YYYY-MM-DD')
            }
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.$v.$touch();

            if (this.$v.$invalid) {
                console.log('err');
            } else {
                this.$refs['confirmation-modal'].show();
            }
        },
        sendRequest() {
            axios.post(this.presentationApiUrl, this.getData())
                .then(response => {
                    this.responseMsg = response.data.message
                }).catch(function (error) {
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        // vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });
        },
        getData() {
            return {
                companyName: this.companyName,
                contactName: this.contactName,
                city: this.city,
                address: this.address,
                phone: this.phone,
                email: this.email,
                schedulePresentation: this.schedulePresentation,
                schedulePresentationTime: this.pickTime,
                message: this.message,
            }
        },
        abortSend() {
            this.$refs['confirmation-modal'].hide();
        },
        confirmSend() {
            this.$refs['confirmation-modal'].hide();
            this.sendRequest();
            this.resetForm();
        },
        resetForm() {
            this.companyName = null;
            this.contactName = null;
            this.city = null;
            this.address = null;
            this.phone = null;
            this.email = null;
            this.schedulePresentation = null;
            this.pickTime = null;
            this.message = null;
            Vue.nextTick(() => {
                this.$v.$reset()
            })
        }
    },
    mounted() {
        // maskedDateTo_input
        // date_pick_2
        console.log(window.APP_API_URL)
        let date_pick_2 = document.getElementById('date_pick_2');
        let maskedDateTo_input = document.getElementById('maskedDateTo_input');
        date_pick_2.inputmask = maskedDateTo_input.inputmask;
        date_pick_2.parentNode.append(maskedDateTo_input);
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style>
.date_input_1 {
    display: none;
}
</style>
